(function () {
  var HEADER_LINK_SELECTOR = [
    '.xo-menu-horizontal__link',
    '.menu-hamburger-drawer-desktop__link',
    '.menu-hamburger-drawer-mobile__link',
    '.menu-hamburger-drawer-mobile__child-link',
    '.menu-hamburger-drawer-mobile__grandchild-link'
  ].join(',');

  function navigateOnFirstClick(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    var link = event.target.closest(HEADER_LINK_SELECTOR);

    if (!link || link.hasAttribute('download')) {
      return;
    }

    var target = link.getAttribute('target');
    var href = link.getAttribute('href');

    if ((target && target !== '_self') || !href || href.charAt(0) === '#') {
      return;
    }

    var destination = new URL(link.href, window.location.href);

    if (destination.protocol !== 'http:' && destination.protocol !== 'https:') {
      return;
    }

    // Some touch browsers consume the first tap to activate the menu's hover
    // state. An explicit navigation keeps the link text single-tap while the
    // separate arrow/collapse trigger continues to open nested mobile menus.
    event.preventDefault();
    window.location.assign(destination.href);
  }

  document.addEventListener('click', navigateOnFirstClick, true);
})();
